module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5pIrwA/tc-custom/9781439642214.jpg?1694225754234",
      "alt": "This image is the cover for the book Baseball in Denver, Images of Baseball"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Baseball in Denver, Images of Baseball\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Images of Baseball: Baseball in Denver shares the city�s prominent role in America�s great game. The lore of baseball�s first pioneers plays out in a real-life soap opera for this Western city. From the early Hall-of-Fame players to the storied baseball-talent barons of Denver�s primitive days, baseball has always been on the forefront of the Denver sports horizon. From Tinker to Satchel Paige to �The Babe� himself, the Mile High City has been a barnstormer�s oasis in a town that was nothing short of the Wild West. The Denver Post Tournament and the rich history of the Denver Bears are highlighted, as well as the many fields and landmarks throughout the city. With the inception of the Colorado Rockies, Denver once again set the stage for big-league baseball, which many of Denver�s local baseball legends have been no stranger to.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matthew Kasper Repplinger II\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Matthew Kasper Repplinger II works for Major League Baseball as a statistician and serves as the president of the Rocky Mountain Chapter of the Society for American Baseball Research. He is the player-manager of the Denver Browns, Denver�s top semiprofessional baseball organization.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0